import { Action } from '@appTypes/Action';
import { Dispatch } from '@reduxjs/toolkit';
import { GetTurnDetailsFromPath } from '../../services/api/GenericClient';
import { TurnDetailResource } from '../../types/TurnDetailResource';
import { TurnPortfolioResource } from '../../types/TurnPortfolioResource';

export enum TurnActionType {
  TURN_DETAIL_LOADING = '[TURN_DETAIL] Turn Detail Loading',
  TURN_DETAIL_LOADED = '[TURN_DETAIL] Turn Detail Loaded',
  TURN_DETAIL_ERROR = '[TURN_DETAIL] Turn Detail Error',
  TURN_DETAIL_REMOVE = '[TURN_DETAIL] Turn Detail Clear Redux',
  TURN_DETAIL_REMOVE_RECORD = '[TURN_DETAIL] Turn Detail Remove Record',
  SELECT_VEHICLE_DETAIL = '[TURN_DETAIL] Select Vehicle Detail',
  POTENTIAL_BUYER_INCREMENT_NOTES_COUNT = '[TURN_DETAIL] Potential buyer notes count increment',
  POTENTIAL_BUYER_UPDATE_LAST_UPDATE = '[TURN_DETAIL] Potential buyer update last update',
}

export const setTurnDetatils =
  (vin: string, dealerId: string) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(turnDetailLoading());
      const path = `/turn/details?vin=${vin}&dealerId=${dealerId}`;

      const response = await GetTurnDetailsFromPath<TurnDetailResource>(path);

      if (!response) {
        dispatch(turnDetailLoaded(null));
      }

      if (response) {
        dispatch(turnDetailLoaded(response));
      }
    } catch (err) {
      dispatch(turnDetailError());
    }
  };

export const turnDetailLoading = (): Action => ({
  type: TurnActionType.TURN_DETAIL_LOADING,
});

export const turnDetailLoaded = (payload: TurnDetailResource): Action => ({
  type: TurnActionType.TURN_DETAIL_LOADED,
  payload: payload,
});

export const turnDetailError = (): Action => ({
  type: TurnActionType.TURN_DETAIL_ERROR,
});

export const turnDetailRemove = (): Action => ({
  type: TurnActionType.TURN_DETAIL_REMOVE,
});

export const turnDetailRemoveRecord = (payload: string): Action => ({
  type: TurnActionType.TURN_DETAIL_REMOVE_RECORD,
  payload: payload,
});

export const selectVehicleDetail = (payload: TurnPortfolioResource | null): Action => ({
  type: TurnActionType.SELECT_VEHICLE_DETAIL,
  payload: payload,
});

export const potentialBuyerIncrementNoteCount = (payload: Record<string, unknown>): Action => ({
  type: TurnActionType.POTENTIAL_BUYER_INCREMENT_NOTES_COUNT as TurnActionType.POTENTIAL_BUYER_INCREMENT_NOTES_COUNT,
  payload: payload,
});

export const potentialBuyerUpdateLastUpdate = (payload: Record<string, unknown>): Action => ({
  type: TurnActionType.POTENTIAL_BUYER_UPDATE_LAST_UPDATE as TurnActionType.POTENTIAL_BUYER_UPDATE_LAST_UPDATE,
  payload: payload,
});

export type TurnDetailActions =
  | ReturnType<typeof turnDetailLoading>
  | ReturnType<typeof turnDetailLoaded>
  | ReturnType<typeof turnDetailError>
  | ReturnType<typeof turnDetailRemove>
  | ReturnType<typeof turnDetailRemoveRecord>
  | ReturnType<typeof selectVehicleDetail>
  | ReturnType<typeof potentialBuyerIncrementNoteCount>
  | ReturnType<typeof potentialBuyerUpdateLastUpdate>;
